import React, {useEffect} from 'react';
import DetailCard from './ui-components/detail-card';
import {sectionLayoutChildAnimation, sectionLayoutParentAnimation,} from '../utils/animations';
import {useInView} from 'react-intersection-observer';
import {motion, useAnimation} from 'framer-motion';

export default function Section5() {
    const controls = useAnimation();
    const {ref, inView} = useInView({threshold: 0.1, triggerOnce: true});

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
        if (!inView) {
            controls.start('hidden');
        }
    }, [controls, inView]);

    const cards = [
        {
            title: 'Beta Access and Future Pricing',
            image: 'scenery_3',
            body: [
                'Discover the comprehensive features of AccuTerra Adapt! Click here to download the beta version of the app and start exploring.',
                'This exclusive opportunity allows you to experience the application firsthand and provide valuable feedback before its official launch. As a thank you for your early support, beta users will secure an exclusive introductory rate of just $19.99 annually per user – and this special pricing is locked in for the lifetime of your contract.',
                'Please note that as AccuTerra Adapt evolves with new features and an expanding range of mapped trails across the United States, we anticipate adjusting our standard pricing.',
                '<a href="https://testflight.apple.com/join/KAEYkxGW" style="text-decoration: underline">Click here to download</a>.'
            ]
        },
    ];

    return (
        <div className="mb-8 border-b-2 border-gray-300">
            <motion.div
                ref={ref}
                initial="hidden"
                animate={controls}
                variants={sectionLayoutParentAnimation}
                className={`text-center   border-gray-200  `}
            >
                <motion.div
                    variants={sectionLayoutChildAnimation}
                    className="max-w-2xl mx-auto text-center"
                >
                    {/*<p className="my-1 text-3xl  text-gray-600 font-bold">
            Give your users the confidence to roam
          </p>
          <p className="my-1  text-lg  font-normal text-gray-700 ">
            Your users expect the best from your application. Rest easy knowing
            you are providing the most reliable maps available.
          </p>*/
                    }
                </motion.div>

                <motion.div variants={sectionLayoutParentAnimation} className="mt-5">
                    {cards.map((card, idx) => (
                        <DetailCard
                            cardBackground={false}
                            key={idx}
                            title={card.title}
                            image={card.image}
                            body={card.body}
                            idx={!(idx % 2)}
                        />
                    ))}
                </motion.div>
            </motion.div>
        </div>
    );
}
